import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';

import Link from 'core/components/Link';

import AvatarBlank from './AvatarBlank.svg';

import { resolveScopedStyles } from 'core/utils/styled-jsx';
import themePropTypes from 'core/utils/prop-types/theme';
import { capitalize } from 'core/utils/string-helper';

import styles from './index.styl';


function UserInfo(props) {
  const {
    theme,
    isMobile,
    userInfo,
  } = props;

  const {
    animations,
    controls: {
      shapka: shapkaStyles,
    },
  } = theme;

  const {
    given_name: givenName,
    family_name: familyName,
  } = userInfo?.attributes || {};

  const hasName = givenName || familyName;

  const desktopFullName = hasName
    ? [givenName, familyName]
      .filter(name => name)
      .map(name => capitalize(name.toLowerCase()))
      .join(' ')
    : 'Личный кабинет';

  let mobileFullName;
  if (givenName && familyName) {
    mobileFullName = `${givenName.charAt(0).toUpperCase()}. ${capitalize(familyName)}`;
  } else if (hasName) {
    mobileFullName = capitalize((givenName || familyName));
  } else {
    mobileFullName = 'Личный кабинет';
  }

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .${styles.userInfo}
          font ${shapkaStyles.link.font}
          letter-spacing ${shapkaStyles.link.letterSpacing}
          text-decoration ${shapkaStyles.link.idle.decoration}
          color ${shapkaStyles.link.idle.color}
          transition color ${animations.hover}
          :hover
            text-decoration ${shapkaStyles.link.hover.decoration}
            color ${shapkaStyles.link.hover.color}
          :active
            text-decoration ${shapkaStyles.link.active.decoration}
            color ${shapkaStyles.link.active.color}

        .${styles.name}
          ${hasName ? 'text-transform: capitalize' : 'text-transform: none'}
      `}
      </style>
    </scope>
  );

  return (
    <Link
      to='/profile'
      type='blank'
      className={scope.wrapClassNames(styles.userInfo)}
    >
      <div className={styles.avatar}>
        <AvatarBlank />
      </div>
      <div title={desktopFullName} className={scope.wrapClassNames(styles.name)}>
        {isMobile ? mobileFullName : desktopFullName}
      </div>
      <scope.styles />
    </Link>
  );
}

const linkContract = '{color, decoration}';

UserInfo.propTypes = {
  userInfo: PropTypes.shape({
    attributes: PropTypes.shape({
      family_name: PropTypes.string,
      given_name: PropTypes.string,
    }),
  }),
  isMobile: PropTypes.bool,
  theme: themePropTypes(`{
    controls: {
      shapka: {
        link: {
          idle: ${linkContract},
        },
      },
    },
    animations: {
      hover
    },
  }`),
};


export default withTheme(withBreakpoint(UserInfo));
